import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import RGPD from "@/pages/RGPD";
import Termos from "@/pages/Termos";
import Privacidade from "@/pages/Privacidade";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/termos" element={<Termos />} />
          <Route path="/rgpd" element={<RGPD />} />
          <Route path="/privacidade" element={<Privacidade />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
